// src/Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './Layout.css'; // Import the CSS for the overlay

function Layout() {
  return (
    <div className="layout">
      <Header />
      <div className="content text-white">
        {/* <img src={logoImage} id="logo"/> */}
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default Layout;
